import * as Yup from "yup";

import { nameRegex } from "@utils/utils";

export const studentValidationSchema = Yup.object().shape({
    firstName: Yup.string()
        .required("Student's first name is required")
        .matches(
            nameRegex,
            "Student's first name can only contain letters, spaces and some special characters: periods (.), apostrophes (') and hyphens (-)"
        ),
    lastName: Yup.string()
        .required("Student's last name is required")
        .matches(
            nameRegex,
            "Student's last name can only contain letters, spaces and some special characters: periods (.), apostrophes (') and hyphens (-)"
        )
});
